import { nomeDoPresente } from './nomeDoPresente';

// Todos os presentes que já têm versão sem fundo. Basta pôr o ficheiro em
// assets/presentes/transparentes/<nome>.mp4 (feito com
// scripts/presentes/recortar.py) e a app passa a usá-lo — não há lista à mão.
const FICHEIROS = import.meta.glob('./assets/presentes/transparentes/*.mp4', {
  eager: true, query: '?url', import: 'default',
});

const POR_NOME = Object.fromEntries(
  Object.entries(FICHEIROS).map(([caminho, url]) => [caminho.split('/').pop().replace(/\.mp4$/, ''), url]),
);

// Url do vídeo sem fundo para este presente, ou null se ainda não existe.
export function videoSemFundo(urlAntigo) {
  const nome = nomeDoPresente(urlAntigo);
  return (nome && POR_NOME[nome]) || null;
}

export const PRESENTES_SEM_FUNDO = Object.keys(POR_NOME);
// Urls de todos os vídeos sem fundo (para aquecer a cache ao entrar numa sala).
export const PRESENTES_SEM_FUNDO_URLS = Object.values(POR_NOME);
